import { createAsyncThunk } from '@reduxjs/toolkit';
import estimateTemplateApi from '~/apis/estimate-template';
import {
  CREATE_ESTIMATE_TEMPLATE,
  GET_ESTIMATE_TEMPLATE,
  GET_ESTIMATE_TEMPLATES,
  UPDATE_ESTIMATE_TEMPLATE,
  UPLOAD_ESTIMATE_TEMPLATE_FILE,
} from '~/utils/constants/actionType';
import {
  IBodyCreateEstimateTemplate,
  IParamsGetEstimateTemplates,
  IResponseGetEstimateTemplate,
  IResponseGetEstimateTemplates,
} from '~/utils/interface/estimate-template';

export const handleCreateEstimateTemplate = createAsyncThunk<
  IBodyCreateEstimateTemplate,
  { data: IBodyCreateEstimateTemplate }
>(CREATE_ESTIMATE_TEMPLATE, async ({ data }, { rejectWithValue }) => {
  try {
    const res = await estimateTemplateApi.createEstimateTemplate(data);
    return res.data.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
export const handleUpdateEstimateTemplate = createAsyncThunk<
  IBodyCreateEstimateTemplate,
  { id: string; data: IBodyCreateEstimateTemplate }
>(UPDATE_ESTIMATE_TEMPLATE, async ({ id, data }, { rejectWithValue }) => {
  try {
    const res = await estimateTemplateApi.updateEstimateTemplate(id, data);
    return res.data.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
export const handleGetEstimateTemplates = createAsyncThunk<
  IResponseGetEstimateTemplates,
  { data: IParamsGetEstimateTemplates }
>(GET_ESTIMATE_TEMPLATES, async ({ data }, { rejectWithValue }) => {
  try {
    const res = await estimateTemplateApi.getEstimateTemplates(data);
    return res.data.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const handleCreateEstimateUploadFiles = createAsyncThunk<null, { data: FormData }>(
  UPLOAD_ESTIMATE_TEMPLATE_FILE,
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await estimateTemplateApi.createUploadFiles(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetEstimateTemplate = createAsyncThunk<IResponseGetEstimateTemplate, string>(
  GET_ESTIMATE_TEMPLATE,
  async (id: string, { rejectWithValue }) => {
    try {
      const res = await estimateTemplateApi.getEstimateTemplate(id);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
